import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { CmsService, ContentSlotData, CurrencyService, Currency, UrlPipe, TranslatePipe } from '@spartacus/core';
import { LaunchDialogService, MediaComponent, FormErrorsComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { KnBrDraftOrder, KnBrDraftOrderEntry } from '../../../../models/kn-br-draft-order.model';
import { KnBrCommonService } from '../../../../services/kn-br-common.service';
import { KnBrDateHelper } from '../../../../shared/kn-br-date.helper';
import { KnBrCartContextService } from '../../../../store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrDraftOrdersService } from '../../../../store/kn-br-draft-orders/kn-br-draft-orders.service';
import { KnBrQuoteReferenceService } from '../../../../store/kn-br-quote-reference/kn-br-quote-reference.service';
import { KnBrDraftOrderCommentsPopupComponent } from '../../kn-br-draft-order-comments-popup/kn-br-draft-order-comments-popup.component';
import { KnBrQuoteReferenceComponent } from '../kn-br-quote-reference/kn-br-quote-reference.component';
import * as _ from 'lodash';
import { Actions, ofType } from '@ngrx/effects';
import { KnBrDraftOrdersActionTypes } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.action';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgbModal, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { KnBrNumbersOnlyDirective } from '../../../../shared/directive/kn-br-numbers-only.directive';
import { KnBrAllowDecimalDirective } from '../../../../shared/directive/kn-br-allow-decimal.directive';
import { AsyncPipe } from '@angular/common';
// Need To Discuss
@Component({
    selector: 'kn-br-draft-order-item',
    templateUrl: './kn-br-draft-order-item.component.html',
    styleUrls: ['./kn-br-draft-order-item.component.scss'],
    providers: [KnBrDateHelper],
    imports: [MediaComponent, RouterLink, NgbInputDatepicker, ReactiveFormsModule, FormErrorsComponent, KnBrNumbersOnlyDirective, KnBrAllowDecimalDirective, AsyncPipe, UrlPipe, TranslatePipe]
})
export class KnBrDraftOrderItemComponent implements OnInit, OnDestroy {
  @Input() entry: KnBrDraftOrderEntry;
  reqShipDate = new FormControl();
  quantity = new FormControl();
  priceAdjusted = new FormControl();
  selectedProductsCodes: number[];
  subscriptionSelectedProduct: Subscription;
  dateFormat$: Observable<any> = this.currentUserService.get().pipe(
    filter((user: any) => user && !!user.dateFormat),
    map((user: any) => user.dateFormat)
  );
  knBrAbsoluteDiscount = new FormControl();
  knBrPercentileDiscount = new FormControl();
  components: ContentSlotData;
  activeCurrency: string;
  subscription = new Subscription();
  currencyData$: Observable<string> = this.currencyService.getActive();
  draftHeaderDiscountType$: Observable<boolean> = this.draftOrdersService.loadDiscountType$();
  isAbsoluteDiscount = false;
  constructor(
    protected currentUserService: UserAccountFacade,
    protected knBrCommonService: KnBrCommonService,
    protected draftOrdersService: KnBrDraftOrdersService,
    protected contextService: KnBrCartContextService,
    protected modalService: NgbModal,
    protected knBrQuoteReferenceService: KnBrQuoteReferenceService,
    protected cdr: ChangeDetectorRef,
    protected cmsService: CmsService,
    protected activeCartService: ActiveCartService,
    protected knBrDateHelper: KnBrDateHelper,
    protected currencyService: CurrencyService,
    protected actions$: Actions
  ) {
    this.subscription.add(
      this.currencyData$.subscribe((currency) => {
        this.currencyService.getAll().subscribe((currencies) => {
          if (currency && currencies?.length) {
            const activeCurrencyObj: Currency = _.find(currencies, ['isocode', currency]);
            this.activeCurrency = activeCurrencyObj ? activeCurrencyObj.symbol : null;
          }
        });
      })
    );
    this.subscription.add(
      this.draftOrdersService.loadDiscountType$().subscribe((value) => {
        this.isAbsoluteDiscount = value;
      })
    );
    this.subscriptionSelectedProduct = this.knBrCommonService.loadCartEntry().subscribe((selectedProductsCodes) => {
      this.selectedProductsCodes = selectedProductsCodes;
    });
    this.actions$.pipe(ofType(KnBrDraftOrdersActionTypes.KnBrDraftOrderEntryUpdateSuccessAction)).subscribe({
      next: (res: any) => {
        if (res.payload.entryData.entryNumber == this.entry.entryNumber) {
          this.entry = res.payload.entryData;
          this.reqShipDate.setValue(this.knBrDateHelper.getDate(this.entry.requestedShipDate));
          this.quantity.setValue(this.entry.quantity);
          this.priceAdjusted.setValue(this.entry.knbrTotalPrice?.priceAdjusted?.value?.toFixed(2));
          this.knBrAbsoluteDiscount.setValue(this.entry.knbrTotalPrice?.knbrAbsoluteDiscount?.value?.toFixed(2));
          this.knBrPercentileDiscount.setValue(this.entry.knbrTotalPrice?.knbrPercentileDiscount);
          this.knBrPercentileDiscount.enable();
          this.knBrAbsoluteDiscount.enable();
          this.reqShipDate.enable();
          this.quantity.enable();
          this.priceAdjusted.enable();
          if (this.entry && this.entry.knbrQuoteReference && this.entry.knbrQuoteReference?.quoteRefNumber) {
            this.quantity.disable();
          }
        }
      },
    });
  }

  ngOnInit(): void {
    if (this.entry) {
      this.reqShipDate.setValue(this.knBrDateHelper.getDate(this.entry.requestedShipDate));
      setTimeout(() => {
        this.reqShipDate.setValue(this.knBrDateHelper.getDate(this.entry.requestedShipDate));
      }, 2000);
      this.quantity.setValue(this.entry.quantity);
      this.priceAdjusted.setValue(this.entry.knbrTotalPrice?.priceAdjusted?.value?.toFixed(2));
      this.knBrAbsoluteDiscount.setValue(this.entry.knbrTotalPrice?.knbrAbsoluteDiscount?.value?.toFixed(2));
      this.knBrPercentileDiscount.setValue(this.entry.knbrTotalPrice?.knbrPercentileDiscount);
      this.knBrPercentileDiscount.enable();
      this.knBrAbsoluteDiscount.enable();
      this.reqShipDate.enable();
      this.quantity.enable();
      this.priceAdjusted.enable();
      if (this.entry && this.entry.knbrQuoteReference && this.entry.knbrQuoteReference?.quoteRefNumber) {
        this.quantity.disable();
      } else {
        this.quantity.enable();
      }
    }
  }

  update(event) {
    if (
      (this.reqShipDate.valid && this.reqShipDate.dirty) ||
      (this.quantity.valid && this.quantity?.dirty) ||
      (this.priceAdjusted.valid && this.priceAdjusted?.dirty)
    ) {
      this.contextService.get$
        .subscribe((value) => {
          const entryObj: any = {
            quantity: this.knBrCommonService.getQuantityBasedOnMoq(
              Number(this.quantity.value) ? Number(this.quantity.value) : 0,
              this.entry.minimumOrderQuantity
            ),
            priceAdjusted: this.priceAdjusted.value,
            requestedShipDate: '',
            entryNumber: this.entry.entryNumber,
            cartCode: value,
          };
          if (this.reqShipDate.value) {
            entryObj.requestedShipDate = this.knBrDateHelper.formatDate(this.reqShipDate.value);
          }
          this.draftOrdersService.updateEntry(entryObj);
          this.reqShipDate.disable();
          this.quantity.disable();
          this.priceAdjusted.disable();
          this.knBrPercentileDiscount.disable();
          this.knBrAbsoluteDiscount.disable();
        })
        .unsubscribe();
    }
  }

  disableQuantity(entry) {
    if (entry && entry.knbrQuoteReference && entry.knbrQuoteReference?.quoteRefNumber) {
      this.quantity.disable();
    } else {
      this.quantity.enable();
    }
  }

  isChecked(code: any): boolean {
    if (this.selectedProductsCodes) {
      return this.selectedProductsCodes.indexOf(code) > -1;
    }
    return false;
  }
  changeCheckBox(event) {
    event.stopPropagation();
    const selectedProductCodes = event.currentTarget.checked ? this.addProductCode() : this.removeProductCode();
    this.knBrCommonService.setCartEntry(selectedProductCodes);
  }

  private addProductCode() {
    if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
      this.selectedProductsCodes.push(this.entry.entryNumber);
    } else {
      this.selectedProductsCodes = [this.entry.entryNumber];
    }
    return this.selectedProductsCodes;
  }
  private removeProductCode() {
    this.selectedProductsCodes.splice(this.selectedProductsCodes.indexOf(this.entry.entryNumber), 1);
    return this.selectedProductsCodes;
  }

  openComment(entry?: KnBrDraftOrderEntry) {
    let modalInstance: any;
    const modalRef = this.modalService.open(KnBrDraftOrderCommentsPopupComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = modalRef.componentInstance;
    modalInstance.entryNumber = entry.entryNumber;
    modalInstance.editable = this.isDisabled();
  }

  openQuoteReference(entry?: KnBrDraftOrderEntry) {
    if (this.isEditable()) {
      this.knBrQuoteReferenceService.get(entry.entryNumber);
      let modalInstance: any;
      const modalRef = this.modalService.open(KnBrQuoteReferenceComponent, {
        centered: true,
        size: 'lg',
      });
      modalInstance = modalRef.componentInstance;
      modalInstance.cartEntry = entry;
    }
  }

  deleteQuoteReference(entry?: KnBrDraftOrderEntry) {
    this.knBrQuoteReferenceService.delete(entry.entryNumber);
  }

  isDisabled() {
    this.cdr.markForCheck();
    this.cmsService
      .getContentSlot('KnBrDraftOrderItemsSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();

    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrDraftOrderItemsComponentReadOnly') ||
      !this.isEditable()
    ) {
      this.reqShipDate.disable();
      this.quantity.disable();
      this.priceAdjusted.disable();
      this.knBrPercentileDiscount.disable();
      this.knBrAbsoluteDiscount.disable();
      return true;
    }
    return false;
  }

  isEditable() {
    let isEditable = true;
    this.activeCartService
      .getActive()
      .subscribe((cart: KnBrDraftOrder) => (isEditable = cart.editable))
      .unsubscribe();
    return isEditable;
  }

  priceAdjust(event) {
    if (
      (this.reqShipDate.valid && this.reqShipDate.dirty) ||
      (this.knBrAbsoluteDiscount.valid && this.knBrAbsoluteDiscount?.dirty) ||
      (this.knBrPercentileDiscount.valid && this.knBrPercentileDiscount?.dirty)
    ) {
      this.contextService.get$
        .subscribe((value) => {
          const entryObj: any = {
            quantity: this.quantity.value,
            requestedShipDate: '',
            entryNumber: this.entry.entryNumber,
            cartCode: value,
          };
          if (this.isAbsoluteDiscount) {
            entryObj.knBrAbsoluteDiscount = event.knBrAbsoluteDiscount;
          } else {
            entryObj.knBrPercentileDiscount = event.knBrPercentileDiscount;
          }
          if (this.reqShipDate.value) {
            entryObj.requestedShipDate = this.knBrDateHelper.formatDate(this.reqShipDate.value);
          }
          this.draftOrdersService.priceadjust(entryObj);
          this.reqShipDate.disable();
          this.quantity.disable();
          this.priceAdjusted.disable();
          this.knBrPercentileDiscount.disable();
          this.knBrAbsoluteDiscount.disable();
        })
        .unsubscribe();
    }
  }

  updatePricePercentileDiscount() {
    const entryObj: any = {
      knBrPercentileDiscount: this.knBrPercentileDiscount.value ? this.knBrPercentileDiscount.value : 0,
      entryNumber: this.entry.entryNumber,
    };
    this.priceAdjust(entryObj);
  }

  updateAbsoluteDiscount() {
    const entryObj: any = {
      knBrAbsoluteDiscount: this.knBrAbsoluteDiscount.value ? this.knBrAbsoluteDiscount.value : 0,
      entryNumber: this.entry.entryNumber,
    };
    this.priceAdjust(entryObj);
  }

  ngOnDestroy(): void {
    if (this.subscriptionSelectedProduct) {
      this.subscriptionSelectedProduct.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
